// 'use strict';

function getLastWord(text) {
  // Find last word
  var patt = /\sand\s|\sor\s|[^a-z0-9 ]|\n/gi;
  // var patt = /\sand\s|\sor\s|[^a-zA-Z0-9\s\w\(\){}[\]!@#$%^&*_;'",.?/:`~|\\\-]+|\n/gi;
  // var patt = /\sand\s|\sor\s|[^a-zA-Z0-9\s\w\(\){}[\]!@#$%^&_ ;'",.?/:`~|\\\-]+|\n/gi;

  var parts = text.split(patt);
  if (parts.length)
    return parts[parts.length - 1];
  return '';
}

export default getLastWord
